import {avatares} from '../../../dados/avatares'

import './Avatar.css'

export default function Avatar({nome, className}){
    const getAvatar = ()=>{
        const avatarEncontrado = avatares.find((avatar)=> avatar.nome === nome)
        return avatarEncontrado?.avatar
    }

    return (
        <img className={className} src={getAvatar()}/>
    )
}